import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';
import { RolesDataRequestPayloadTypes } from '../models/user-management';

const UserRoleService = {
  fetchRoleList: async (payload?: RolesDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.USER_SERVICE_BASE_URL + '/roles', { params: payload });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addNewRole: async (payload: object) => {
    try {
      const apiResponse = await axiosClient.post(apiPath.USER_SERVICE_BASE_URL + '/roles', payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  deleteRoles: async (payload: any) => {
    try {
      const reqParams = payload.map((item: any) => {
        return item;
      });

      const apiResponse = await axiosClient.delete(apiPath.USER_SERVICE_BASE_URL + '/roles', {
        data: { role_ids: [...reqParams] },
      });
      return {
        status: 'success',
        code: apiResponse?.status,
        data: payload,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchRoleAccessList: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.USER_SERVICE_BASE_URL + '/roles/' + payload);
      const res = apiResponse?.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateRoleAccessList: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.put(apiPath.USER_SERVICE_BASE_URL + '/roles/' + payload.id, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default UserRoleService;
